/**
 * Time window for an announceBar (the Summit "we are live, join here" banner,
 * mct_5d67f69a-c0a). `showFrom` / `showUntil` are ISO instants WITH an explicit
 * offset (e.g. 2026-11-04T08:00:00-05:00), so the wall-clock Toronto time is
 * readable in the config. `showUntil` is exclusive. A bar with no window is
 * always open. An unparseable bound fails closed (hidden), never shown forever.
 */
export interface AnnounceWindow {
  showFrom?: string;
  showUntil?: string;
}

export function announceWindowOpen(w: AnnounceWindow, nowMs: number): boolean {
  if (w.showFrom !== undefined) {
    const from = Date.parse(w.showFrom);
    if (Number.isNaN(from) || nowMs < from) return false;
  }
  if (w.showUntil !== undefined) {
    const until = Date.parse(w.showUntil);
    if (Number.isNaN(until) || nowMs >= until) return false;
  }
  return true;
}
